export default {
      id: "icon-search-usage",
      viewBox: "0 0 20.475 20.973",
      url: __webpack_public_path__ + "img/icons.svg#icon-search",
      toString: function () {
        return this.url;
      }
    }